import { render, staticRenderFns } from "./SchedulePickupsTablePeakCreatedPickups.vue?vue&type=template&id=93fa9324&"
import script from "./SchedulePickupsTablePeakCreatedPickups.vue?vue&type=script&lang=js&"
export * from "./SchedulePickupsTablePeakCreatedPickups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports